import { Box, Button, Modal, TextField, useMediaQuery } from "@mui/material"
import { useFormik } from "formik"
import React, { useState } from "react"
import * as yup from "yup"
import Header from "../../components/Header"
import RoleApi from "../../services/api/roles"
import { useEffect } from "react"

function RoleForm({ formData, open, handleClose }) {
	const isNonMobile = useMediaQuery("(min-width:600px)")
	const [isEdit, setIsEdit] = useState(false)

	const modalStyle = {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	}

	const preventCloseBackdrop = (props) => (
		<div {...props} style={{ pointerEvents: "none" }} />
	)

	const formik = useFormik({
		initialValues: initialValues,
		validationSchema: checkoutSchema,

		onSubmit: async (values, { resetForm }) => {
			if (isEdit) {
				editRole(values)
			} else {
				createRole(values)
			}

			resetForm()
		},
	})

	useEffect(() => {
		if (formData) {
			formik.setValues({
				...formData,
			})

			setIsEdit(true)
		} else {
			formik.setValues({
				...initialValues,
			})
			setIsEdit(false)
		}
	}, [formData])

	const createRole = async (values) => {
		const response = await RoleApi().create(values)

		console.log(createdSuccessMsg, response)
		handleClose()
	}

	const editRole = async (values) => {
		const response = await RoleApi().edit(formData.id, values)

		console.log(updatedSuccessMsg, response)
		handleClose()
	}

	const modalBody = (
		<Box
			sx={{
				width: "60%",
				bgcolor: "background.paper",
				boxShadow: 24,
				p: 2,
			}}
		>
			<Header title="Role Detail" subtitle="" />

			<form onSubmit={formik.handleSubmit}>
				<Box
					display="grid"
					gap="30px"
					gridTemplateColumns="repeat(4, minmax(0, 1fr))"
					sx={{
						"& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
					}}
				>
					<TextField
						fullWidth
						variant="filled"
						type="text"
						label="Name"
						autoComplete="off"
						onBlur={formik.handleBlur}
						onChange={formik.handleChange}
						name="name"
						value={formik.values.name}
						inputProps={{ maxLength: 50 }}
						error={!!formik.touched.name && !!formik.errors.name}
						helperText={formik.touched.name && formik.errors.name}
						sx={{ gridColumn: "span 4" }}
					/>
				</Box>
				<Box display="flex" justifyContent="space-between" mt="20px">
					<Button variant="contained" onClick={handleClose}>
						Close
					</Button>
					<Button type="submit" color="secondary" variant="contained">
						{isEdit ? "Update Role" : "Create New Role"}
					</Button>
				</Box>
			</form>
		</Box>
	)

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
			style={modalStyle}
			BackdropComponent={preventCloseBackdrop}
		>
			{modalBody}
		</Modal>
	)
}

const checkoutSchema = yup.object().shape({
	name: yup
		.string()
		.required("required")
		.max(50, "Maximum characters limit exceeds"),
})

const initialValues = {
	name: "",
}

const createdSuccessMsg = "Role created: "
const updatedSuccessMsg = "Role updated: "

export default RoleForm
